module.exports = __webpack_public_path__ + "static/media/starts_with_i.822bced0.mp3";